import { AudienceDataModeSlider } from "@/components/audience-data/AudienceDataModeSlider";
import { AudienceDataGoogleConversionNameFields } from "@/components/audience-data/AudienceDataGoogleConversionNameFields";
import {
  audienceExportColumns,
  GOOGLE_ADS_TIMEZONE_PARAM,
  type SsdExportDestination,
} from "@/lib/ssd/ssdExportPreview";
import type { SsdGoogleConversions } from "@/lib/ssdSalesClient";

export function AudienceDataExportPreview(props: {
  destination: SsdExportDestination;
  onDestination: (d: SsdExportDestination) => void;
  conversions: SsdGoogleConversions;
  savingConversions: boolean;
  onSelectConversion: (name: string) => void;
  onAddConversion: (name: string) => void;
}) {
  const cols = audienceExportColumns(props.destination, props.conversions.selected);
  return (
    <div className="min-w-0 space-y-2">
      <AudienceDataModeSlider
        value={props.destination}
        onChange={props.onDestination}
        ariaLabel="Export format"
        tabs={[
          { id: "google", label: "Google" },
          { id: "meta", label: "Meta" },
        ]}
      />
      {props.destination === "google" ? (
        <>
          <p className="text-xs text-gray-600 dark:text-zinc-400">
            Row 1 column A is <span className="font-mono">{GOOGLE_ADS_TIMEZONE_PARAM}</span>. Headers start on row 2.
          </p>
          <AudienceDataGoogleConversionNameFields
            conversions={props.conversions}
            saving={props.savingConversions}
            onSelect={props.onSelectConversion}
            onAdd={props.onAddConversion}
          />
        </>
      ) : null}
      <div className="min-w-0 overflow-x-auto">
        <table className="min-w-full text-left text-sm">
          <thead>
            <tr className="border-b border-gray-200 text-xs uppercase tracking-wide text-gray-500 dark:border-zinc-700 dark:text-zinc-400">
              <th className="py-2 pr-3 font-medium">Header</th>
              <th className="py-2 pr-3 font-medium">Type</th>
              <th className="py-2 font-medium">Example</th>
            </tr>
          </thead>
          <tbody>
            {cols.map((col) => (
              <tr key={col.header} className="border-b border-gray-100 dark:border-zinc-800">
                <td className="whitespace-nowrap py-1.5 pr-3 font-medium">{col.header}</td>
                <td className="whitespace-nowrap py-1.5 pr-3">
                  {col.type}
                  <span className="block text-xs font-normal text-gray-500 dark:text-zinc-400">{col.note}</span>
                </td>
                <td className="max-w-[10rem] truncate py-1.5 font-mono text-xs" title={col.example}>
                  {col.example}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
